import { SearchOutlined } from '@ant-design/icons';
import { Flex, Input, Tree } from 'antd';
import { useCallback, useEffect, useMemo, useState } from 'react';

import type { ContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import { PF } from '@pages/Clients/NewClientsList/data/constants';
import { FilterWrapper } from '@pages/Clients/NewClientsList/ui/FilterWrapper';

export const ServicesFilter: ContentType = ({ open, onClose, id }) => {
  const [localSearch, setLocalSearch] = useState<string>('');

  const { filtersMap, getServicesTreeBySearch, onChangeServices } =
    useNewClientsListContext();

  const { services } = filtersMap.get(id)!;

  const [selectedServices, setSelectedServices] = useState<string[]>(services);

  const onCheck = useCallback(
    (
      checkedKeys:
        | React.Key[]
        | { checked: React.Key[]; halfChecked: React.Key[] }
    ) => {
      if (Array.isArray(checkedKeys)) {
        setSelectedServices(checkedKeys as string[]);
      } else {
        setSelectedServices(checkedKeys.checked as string[]);
      }
    },
    []
  );

  const filteredServicesTree = useMemo(
    () => getServicesTreeBySearch(localSearch),
    [localSearch, getServicesTreeBySearch]
  );

  useEffect(() => {
    if (open) {
      setSelectedServices(services);
    } else {
      setLocalSearch('');
      setSelectedServices([]);
    }
  }, [open, services]);

  const onConfirm = useCallback(() => {
    onChangeServices(selectedServices, id);
    onClose?.();
  }, [onClose, onChangeServices, selectedServices, id]);

  return (
    <FilterWrapper onConfirm={onConfirm}>
      <Flex vertical gap={8}>
        <Input
          placeholder="Поиск по услугам"
          value={localSearch}
          onChange={(e) => setLocalSearch(e.target.value)}
          prefix={<SearchOutlined />}
        />
        <div className={`${PF}__tree-container`}>
          <div className={`${PF}__tags-list`}>
            <Tree
              checkable
              showIcon
              onCheck={onCheck}
              treeData={filteredServicesTree}
              checkedKeys={selectedServices}
              expandAction="click"
            />
          </div>
        </div>
      </Flex>
    </FilterWrapper>
  );
};
